// libs
import React, { memo } from 'react';

// defs
interface IconSelectedProps {
  iconWidth?: number;
  className?: string;
}

function IconSelected({ iconWidth = 24, className = '' }: IconSelectedProps) {
  return (
    <svg
      className={className}
      width={iconWidth}
      height={iconWidth}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
        fill="#001325"
      />
      <path
        d="M10.8536 15.4993C10.5436 15.4993 10.5436 15.4993 8.22357 13.1793C8.15281 13.1104 8.09658 13.028 8.05818 12.937C8.01978 12.8459 8 12.7481 8 12.6493C8 12.5505 8.01978 12.4528 8.05818 12.3617C8.09658 12.2707 8.15281 12.1883 8.22357 12.1193C8.3642 11.9789 8.55482 11.9 8.75357 11.9C8.95232 11.9 9.14294 11.9789 9.28357 12.1193L10.8536 13.6893L15.2936 9.21934C15.4342 9.07889 15.6248 9 15.8236 9C16.0223 9 16.2129 9.07889 16.3536 9.21934C16.4243 9.28829 16.4806 9.3707 16.519 9.46173C16.5574 9.55275 16.5771 9.65055 16.5771 9.74934C16.5771 9.84813 16.5574 9.94593 16.519 10.037C16.4806 10.128 16.4243 10.2104 16.3536 10.2793L11.3536 15.2793C11.2205 15.4129 11.042 15.4915 10.8536 15.4993Z"
        fill="white"
      />
    </svg>
  );
}

export default memo(IconSelected);
